import React, { memo, useMemo } from 'react';
import { Box, Stack, Alert } from '@mui/material';
import { CompanyListProps } from './types';
import { useCompaniesData } from './useCompaniesData';
import { CompanyGrid } from './CompanyGrid';
import { ViewMoreButton } from './ViewMoreButton';
import { COMPANY_LIST_CONSTANTS } from './constants';


const CompanyListComponent: React.FC<CompanyListProps> = ({
  maxCompanies = COMPANY_LIST_CONSTANTS.MAX_COMPANIES_DISPLAY,
  showOnlyWithReferrers = true,
  className,
}) => {
  const { companies, error } = useCompaniesData();

  const filteredCompanies = useMemo(() => {
    let filtered = companies;
    
    if (showOnlyWithReferrers) {
      filtered = filtered.filter(company => company.referrerCount > 0);
    }
    
    return filtered.slice(0, maxCompanies);
  }, [companies, showOnlyWithReferrers, maxCompanies]);

  const containerStyles = useMemo(() => ({
    margin: '40px auto',
    py: 0,
    maxWidth: 1280,
    width: '100%',
    boxSizing: 'border-box',
    ...(className && { className }),
  }), [className]);

  const { SPACING } = COMPANY_LIST_CONSTANTS;

  return (
    <Box sx={containerStyles}>
      <Stack spacing={SPACING.section} alignItems="center">

        {error && (
          <Alert 
            severity="error" 
            sx={{ width: '100%', maxWidth: 600 }}
            role="alert"
          >
            載入公司列表失敗：{error}
          </Alert>
        )}

        <CompanyGrid companies={filteredCompanies} />

      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 4 }}>
        <ViewMoreButton />
      </Box>
    </Box>
  );
};


export const CompanyList = memo(CompanyListComponent);

CompanyList.displayName = 'CompanyList';

export default CompanyList;
